var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.compatibleAudioComponents)?_c('a',{attrs:{"href":"#","data-bs-toggle":"tooltip","data-bs-placement":"top","title":_vm.$t('Toggle audio autoplay') + ' (beta)'},on:{"click":function($event){$event.preventDefault();return _vm.toggleAutoplay.apply(null, arguments)},"mouseover":_vm.showTooltip,"mouseleave":_vm.hideTooltip}},[_c('i',{class:{
      fas: true,
      'fa-podcast': true,
      'text-success': _vm.autoplay,
    }})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }